module.exports = __webpack_public_path__ + "img/m6luoding.prt.9c41513a.jpg";